import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import { SubmitButton } from 'lp-components';
import { useEffect, useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { H1, P, PRE_QUALIFICATION_ACCEPT_DECLINED_URL, WIZARD_URL, AFF_NUMBER, AnalyticsContext, } from 'shared';
import { useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery } from 'consumer-applications-v1-api';
import failIcon from 'images/utility-icons/warn.svg';
import { setApprovedApplication } from '../../actions';
function PendHandler({ iframeUrl, personalInfo, prequalification, }) {
    const [submitting, setSubmitting] = useState(false);
    const [isStillPending, setIsStillPending] = useState(false);
    const [ssnLastFour, setSsnLastFour] = useState('');
    const [getCreditApplicationsByStatus] = useLazyGetConsumerApplicationsV1CreditApplicationsStatusStatusQuery();
    const history = useHistory();
    const dispatch = useDispatch();
    const { analytics } = useContext(AnalyticsContext);
    useEffect(() => {
        if (personalInfo.ssn) {
            setSsnLastFour(personalInfo.ssn.slice(-4));
        }
        else if (personalInfo.ssnLast4) {
            setSsnLastFour(personalInfo.ssnLast4);
        }
    }, []);
    const submit = () => {
        setSubmitting(true);
        pendHandlingComplete();
    };
    const pendHandlingComplete = () => {
        setIsStillPending(false);
        getCreditApplicationsByStatus({
            status: 'pending',
            ssnLastFour: ssnLastFour,
            dateOfBirth: personalInfo.dateOfBirth,
            zip: personalInfo.zip,
            locationId: prequalification.location.locationId,
        }).then((res) => {
            const { data } = res;
            if (data && data.creditApplication?.applicationStatus === 'approved') {
                analytics?.track('ApplicationApproved', {});
                dispatch(setApprovedApplication(data.creditApplication));
                history.push({
                    pathname: WIZARD_URL,
                    state: {
                        step: 'APPROVAL',
                    },
                });
            }
            else if (data &&
                data.creditApplication?.applicationStatus === 'declined') {
                history.push(PRE_QUALIFICATION_ACCEPT_DECLINED_URL);
            }
            else {
                setIsStillPending(true);
                setSubmitting(false);
            }
        });
    };
    const openWindow = () => {
        if (isStillPending) {
            submit();
        }
        else {
            popupCenter(iframeUrl, 'Alphaeon Verification', 600, 800);
        }
    };
    const popupCenter = (url, title, w, h) => {
        // Fixes dual-screen position                             Most browsers      Firefox
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;
        const systemZoom = width / window.screen.availWidth;
        const left = (width - w) / 2 / systemZoom + dualScreenLeft;
        const top = (height - h) / 2 / systemZoom + dualScreenTop;
        const newWindow = window.open(url, title, `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `);
        newWindow?.focus;
        const interval = setInterval(() => {
            if (newWindow?.closed) {
                clearInterval(interval);
                submit();
            }
        }, 500);
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content text-center", children: [_jsx("div", { className: "step-up-pend-img", children: _jsx("img", { src: failIcon, alt: "red fail icon" }) }), _jsxs("div", { className: "pad-y-20", children: [_jsx(H1, { children: "Almost Done!" }), isStillPending ? (_jsxs(_Fragment, { children: [_jsx(P, { variant: "title-large", children: "Your application is still pending. It may take a few minutes for us to receive notification that the verification steps are complete. Please occassionally refresh the status to see if there are any updates. If there are no updates after 5 minutes, please call us." }), _jsx("div", { className: "number-container", children: _jsxs("div", { className: "flex-center text-center mar-b-20", children: [_jsx(LocalPhoneIcon, {}), " \u00A0\u00A0\u00A0", _jsx("div", { children: _jsx("a", { href: `tel:${AFF_NUMBER}`, children: AFF_NUMBER }) })] }) })] })) : (_jsx(P, { variant: "title-large", children: "We need to verify some info before your application is complete." })), _jsxs("div", { children: [prequalification?.lenderRequestReferenceId && (_jsxs(P, { variant: "title-large", children: [' ', "Application ID: ", prequalification?.lenderRequestReferenceId] })), _jsx(SubmitButton, { type: "button", className: "button-warn qualify mar-t-0", onClick: () => openWindow(), submitting: submitting, children: isStillPending ? 'Refresh Status' : 'Start Verification' })] })] })] }) }) }));
}
export default PendHandler;
